import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

//Include Both Helper File with needed methods
import { postJwtLogin } from "../../../helpers/blopsleads_helper"
import {
    postFakeLogin,
    // postJwtLogin,
    postSocialLogin,
} from "../../../helpers/fakebackend_helper"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    const authProvider = (process.env.REACT_APP_DEFAULTAUTH || "jwt").toLowerCase()

    if (authProvider === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      )
      yield put(loginSuccess(response))
    } else if (authProvider === "jwt") {
      const response = yield call(postJwtLogin, {
        // Modificar dados enviados no formato solicitado pelo Serviço de Autenticação  ***************
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      window.sessionStorage.setItem("authUser", JSON.stringify(response))

      if (response.status === 2) {
        history.push("/reset-password", { email: user.email })
      } else {
        yield put(loginSuccess(response))
        yield put(apiError(null))

        history.push("/qualificacao")
      }
    } else if (authProvider === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      // fallback seguro
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      window.sessionStorage.setItem("authUser", JSON.stringify(response))
      if (response.status === 2) {
        history.push("/reset-password", { email: user.email })
      } else {
        yield put(loginSuccess(response))
        yield put(apiError(null))
        history.push("/qualificacao")
      }
    }
  } catch (error) {
    console.log('🔍 Erro detalhado de login:', error)
    
    // Melhor tratamento de erros para distinguir problemas de conexão de CORS
    if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND' || error.code === 'ECONNRESET') {
      yield put(apiError('Servidor de autenticação não encontrado. Verifique a conexão.', 0))
    } else if (error.code === 'ECONNABORTED') {
      yield put(apiError('Timeout na conexão. Servidor pode estar offline.', 0))
    } else if (error.message && error.message.includes('CORS')) {
      yield put(apiError('Erro de CORS. Verifique as configurações do servidor.', 0))
    } else if (error.response) {
      // Erro com resposta do servidor
      const message = error.response.data?.message || 'Erro de autenticação'
      yield put(apiError(message, error.response.status))
    } else {
      // Erro sem resposta (possivelmente rede/CORS)
      yield put(apiError('Erro de conexão ou CORS. Verifique a URL do servidor.', 0))
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    window.sessionStorage.removeItem("authUser")

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(fireBaseBackend.socialLoginUser, data, type)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/qualificacao")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
